/**
 * API Configuration
 * 環境に応じたAPI接続設定
 */

// 環境変数から設定を取得
const API_URL = import.meta.env.VITE_API_URL || '/api/v1'
const WS_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:3001/api/v1'

// 動的WebSocket URL生成
export function getWebSocketUrl(path: string): string {
  // 本番環境の場合は環境変数のURLを使用
  if (import.meta.env.PROD && import.meta.env.VITE_WS_URL) {
    return `${import.meta.env.VITE_WS_URL}${path}`
  }

  // 開発環境の場合は現在のホストから動的に生成
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const host = window.location.host
  return `${protocol}//${host}/api/v1${path}`
}

// API設定エクスポート
export const apiConfig = {
  baseURL: API_URL,
  wsBaseURL: WS_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
}

// API URL生成ヘルパー
export function getApiUrl(path: string): string {
  return `${API_URL}${path}`
}

// 認証トークンの管理
export const tokenManager = {
  getToken(): string | null {
    return localStorage.getItem('auth_token')
  },

  setToken(token: string): void {
    localStorage.setItem('auth_token', token)
  },

  removeToken(): void {
    localStorage.removeItem('auth_token')
  },

  getAuthHeader(): Record<string, string> {
    const token = this.getToken()
    return token ? { Authorization: `Bearer ${token}` } : {}
  }
}

export default apiConfig